import { CryptoBundleComponent } from './pages/crypto-bundle/crypto-bundle.component';
import { AccountsComponent } from './pages/profile/accounts/accounts.component';
import { SwapComponent } from './pages/swap/swap.component';
import { SecurityComponent } from './pages/profile/security/security.component';
import { DocumentationComponent } from './pages/profile/documentation/documentation.component';
import { PersonalInformationComponent } from './pages/profile/personal-information/personal-information.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardGuard } from 'src/app/guards/dashboard.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CryptoTabComponent } from './pages/crypto-tab/crypto-tab.component';
import { HistoryComponent } from './pages/history/history.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { UserDashComponent } from './pages/user-dash/user-dash.component';
import { CryptoExchangeComponent } from './pages/crypto-tab/crypto-exchange/crypto-exchange.component';
import { PayrollComponent } from './pages/payroll/payroll.component';
import { CommerceComponent } from './pages/commerce/commerce.component';
import { ChargeFormComponent } from './pages/user-dash/commerce-dash/charge-form/charge-form.component';
import { CommerceProfileComponent } from './pages/profile/commerce-profile/commerce-profile.component';
import { DetailCryptoCardComponent } from './pages/crypto-tab/crypto-exchange/detail-crypto-card/detail-crypto-card.component';
import { IsVisibleCardGuard } from 'src/app/guards/is-visible-card.guard';
import { GroupComponent } from './pages/group/group.component';
import { ArbitrageComponent } from './pages/profile/arbitrage/arbitrage.component';
import { DcaComponent } from './pages/dca/dca.component';
import { CreateRulesComponent } from './pages/dca/create-rules/create-rules.component';
import { MyAutomationsComponent } from './pages/dca/my-automations/my-automations.component';
import { MakeTradeComponent } from './pages/group/make-trade/make-trade.component';
import { SelfieComponent } from './pages/profile/selfie/selfie.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: '',
        component: UserDashComponent,
      },
      { path: 'charge', component: ChargeFormComponent, canActivate: [DashboardGuard] },
      { path: 'history', component: HistoryComponent, canActivate: [DashboardGuard] },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [DashboardGuard],
        children: [
          { path: '', redirectTo: 'information', pathMatch: 'full' },
          { path: 'information', component: PersonalInformationComponent },
          { path: 'accounts', component: AccountsComponent },
          { path: 'documentation', component: DocumentationComponent },
          { path: 'arbitrage', component: ArbitrageComponent },
          { path: 'security', component: SecurityComponent },
          { path: 'commerce', component: CommerceProfileComponent },
          { path: 'selfie', component: SelfieComponent },
          // { path: 'referral', component: ProfileReferralComponent },
        ],
      },
      // { path: 'referral', component: ReferralComponent, canActivate: [DashboardGuard] },
      { path: 'user/:orderId', component: UserDashComponent, canActivate: [DashboardGuard] },
      { path: 'user/discount/:code', component: UserDashComponent, canActivate: [DashboardGuard] },
      {
        path: 'crypto-exchange',
        component: CryptoTabComponent,
        canActivate: [DashboardGuard],
        children: [
          {
            path: '',
            component: CryptoExchangeComponent,
            children: [
              {
                path: ':ticker',
                component: DetailCryptoCardComponent,
                canActivate: [IsVisibleCardGuard],
              },
            ],
          },
        ],
      },
      {
        path: 'dca',
        component: DcaComponent,
        canActivate: [DashboardGuard],
        children: [
          {
            path: '',
            component: MyAutomationsComponent,
          },
          {
            path: 'create',
            component: CreateRulesComponent,
          },
        ],
      },
      // { path: 'aust', component: CryptoStakingComponent, canActivate: [DashboardGuard] },
      { path: 'swap', component: SwapComponent, canActivate: [DashboardGuard] },
      {
        path: 'grupos',
        canActivate: [DashboardGuard],
        children: [
          {
            path: '',
            component: GroupComponent,
          },
          {
            path: 'trade',
            component: MakeTradeComponent,
          },
        ],
      },
      { path: 'canastas', component: CryptoBundleComponent, canActivate: [DashboardGuard] },
      { path: 'history', component: HistoryComponent, canActivate: [DashboardGuard] },
      { path: 'payroll', component: PayrollComponent, canActivate: [DashboardGuard] },
      { path: 'commerce', component: CommerceComponent, canActivate: [DashboardGuard] },
      { path: '**', redirectTo: '/' },
    ],
  },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreModuleRoutingModule {}
